import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useInsights } from '../../hooks/useInsights';

const PatientBookingSummaryChart = () => {
        const { data: insights} = useInsights();
    
  const chartData = {
    labels: ['Today', 'This Week', 'This Month'],
    series: [
      insights?.bookingsToday ?? 0,
      insights?.bookingsThisWeek ?? 0,
      insights?.bookingsThisMonth ?? 0
    ]  };

  const chartOptions = {
    chart: {
      type: 'polarArea',
    },
    labels: chartData.labels,
    stroke: {
      colors: ['#fff'],
    },
    fill: {
      opacity: 0.9,
    },
    legend: {
      position: 'bottom',
    },
    colors: [ '#FEBA17','#298E9F', '#195761'], // matching your brand colors
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  return (
    <div className=" rounded-xl p-6  ">
      <h2 className="text-xl font-bold text-textPrimary text-center mb-4">
        Patient Booking Summary
      </h2>

      <ReactApexChart
        options={chartOptions}
        series={chartData.series}
        type="polarArea"
        height={350}
      />
    </div>
  );
};

export default PatientBookingSummaryChart;
